import { useImmer } from 'use-immer';
import { STORAGE_PRICING, StoragePricing } from '../const';

export const useStoragePricingForm = (initialState: Partial<StoragePricing> = {}) =>
  useImmer({ ...STORAGE_PRICING, ...initialState } as StoragePricing);
